import { createContext } from 'react';

import {
  SubscriptionsInterpreter,
  ProductCatalogInterpreter,
  ModalsInterpreter,
  PaymentGatewayInterpreter,
} from '../machines';

export const GlobalStateContext = createContext<{
  subscriptionsService: SubscriptionsInterpreter;
  productCatalogService: ProductCatalogInterpreter;
  modalsService: ModalsInterpreter;
  paymentGatewayService: PaymentGatewayInterpreter;
}>({
  paymentGatewayService: null,
  subscriptionsService: null,
  productCatalogService: null,
  modalsService: null,
});
